export default "__VITE_ASSET__CxWnqaS5__"